import { render } from "./createFund.vue?vue&type=template&id=f598ca4c&scoped=true"
import script from "./createFund.vue?vue&type=script&lang=js"
export * from "./createFund.vue?vue&type=script&lang=js"

import "./createFund.vue?vue&type=style&index=0&id=f598ca4c&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f598ca4c"]])

export default __exports__